import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Book, Brain, Eye, Map as MapIcon, Calendar } from 'lucide-react';
export function ContentSection() {
  const modules = [{
    title: 'Módulo 1',
    desc: 'Cómo funciona la memoria',
    icon: Book,
    color: 'text-blue-400'
  }, {
    title: 'Módulo 2',
    desc: 'Método M3',
    icon: Brain,
    color: 'text-cyan-400'
  }, {
    title: 'Módulo 3',
    desc: 'Asociación visual',
    icon: Eye,
    color: 'text-purple-400'
  }, {
    title: 'Módulo 4',
    desc: 'Palacio de memoria',
    icon: MapIcon,
    color: 'text-cerebro-orange'
  }, {
    title: 'Módulo 5',
    desc: 'Rutina diaria de entrenamiento mental',
    icon: Calendar,
    color: 'text-green-400'
  }];
  return <section className="py-24 relative bg-slate-900/40" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-25">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-26">
            ¿Qué incluye el ebook?
          </h2>
          <div className="w-24 h-1 bg-purple-500 mx-auto rounded-full shadow-[0_0_10px_rgba(168,85,247,0.5)]" data-id="element-27"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-28">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`glass-card p-8 border-l-4 border-l-transparent hover:border-l-${mod.color.split('-')[1]}-400 transition-all duration-300 group ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-29">
              <div className="flex items-start gap-4" data-id="element-30">
                <div className={`p-3 rounded-xl bg-slate-800 group-hover:scale-110 transition-transform ${mod.color}`} data-id="element-31">
                  <mod.icon className="w-6 h-6" data-id="element-32" />
                </div>
                <div data-id="element-33">
                  <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-34">
                    {mod.title}
                  </h4>
                  <p className="text-xl font-medium text-white" data-id="element-35">{mod.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}